// ESLint Settings
/* eslint complexity: "off", no-unused-labels: "off", no-useless-escape: "off" */
/* globals site: true, rb: true, TweenMax: true */

(function ($) {
  'use strict';

  Drupal.behaviors.MPPCarouselCustomV2 = {
    /* eslint-disable no-unused-vars */
    attach: function (context, settings) {
    /* eslint-enable no-unused-vars */
      // DOM
      var $window = $(window);

      // /////////////////////////////////
      // BEGIN: MPP Carousel Custom functionality
      // /////////////////////////////////
      (function () {
        // DOM
        var $mpp = $('.custom-mpp', context);
        var $mppCarousel = $mpp.filter('.mpp-carousel');
        // LOGIC
        var carouselSettings = {
          useGSAP: true,
          offset: '5%',
          increment: '33.3%',
          duration: 0.5
        };
        var platformVars = {
          $target: undefined,
          isMobile: false,
          isDesktop: false,
          isIpad: false,
          ieVersion: -1,
          mobileSize: 767,
          init: function ($target) {
            /*
                  * @function getInternetExplorerVersion
                  * @description Returns the version of Internet Explorer or a -1 (indicating the use of another browser).
                  * @see: https://msdn.microsoft.com/en-us/library/ms537509(v=vs.85).aspx
                  * @returns {Number} -1 if not any IE version, any other number otherwise
                  */
            function getInternetExplorerVersion() {
              var rv = -1;
              var ua;
              var re;

              // works up to IE 10 but IE 11 spoofs this value. seperate check for IE Edge
              if (navigator.appName === 'Microsoft Internet Explorer') {
                ua = navigator.userAgent;
                re = new RegExp('MSIE ([0-9]{1,}[\.0-9]{0,})');

                if (re.exec(ua) !== null) {
                  rv = parseFloat(RegExp.$1);
                }
              } else if (navigator.appName === 'Netscape' && navigator.userAgent.indexOf('Trident') > -1) {
                rv = 11;
              } else if (navigator.appName === 'Netscape' && navigator.userAgent.indexOf('Edge') > -1) {
                ua = navigator.userAgent;
                re = new RegExp('Edge\/([0-9]{1,}[\.0-9]{0,})');

                if (re.exec(ua) !== null) {
                  rv = parseFloat(RegExp.$1);
                }
              }

              return rv;
            }

            // Set platform targets
            this.$target = $target;

            // Initial mobile checks (additional checks will be needed for 'desktop mobile' sizes)
            this.isMobile = typeof site !== 'undefined' ? site.client.isMobile : (/iphone|ipod|android|blackberry|mini|windows\sce|palm/i).test(navigator.userAgent.toLowerCase());
            this.isDesktop = !this.isMobile;
            this.isIpad = navigator.userAgent.toLowerCase().match(/ipad/i) !== null;
            this.ieVersion = getInternetExplorerVersion();

            // set classes for desktop/mobile/ipad/ie
            if (this.isIpad) {
              $target.addClass('ipad');
            } else {
              $target.addClass(this.isMobile ? 'mobile' : 'desktop');
            }

            if (this.ieVersion !== -1) {
              $target.addClass('ie');
            }

            if (this.ieVersion === 9) {
              $target.addClass('ie-9');
            }

            if (this.isDesktop) {
              this.isMobile = $(window).width() <= this.mobileSize;

              if (this.isMobile) {
                $target.addClass('mobile');
              }
            }
          }
        };

        // BEGIN: Init
        init: {
          platformVars.init($mpp);

          // Build carousels
          $mppCarousel.each(function () {
            $(this).find('.carousel').elCarousel(carouselSettings);
          });

          // Populate each MPP with product data
          $mpp.each(function () {
            // DOM
            var $this = $(this);
            var $carousel = $this.find('.carousel');
            var $productList = $this.find('.el-product_id-list');
            // LOGIC
            var imageType = (typeof $this.data('product-image-source') === 'undefined' ? '' : $this.data('product-image-source')).toUpperCase();
            var titleType = (typeof $this.data('product-title-source') === 'undefined' ? '' : $this.data('product-title-source')).toLowerCase();

            // Gets and returns the eyebrow text for given MISC_FLAG
            function getEyebrowText(flag) {
              var result = '';

              // If rb or rb.endeca (localization stuff is not defined, just return an empty string);
              if (typeof rb === 'undefined' || typeof rb.endeca === 'undefined') {
                return result;
              }

              switch (flag) {
                case 1:
                  result = rb.endeca.misc_flag_new;
                  break;

                case 2:
                  result = rb.endeca.misc_flag_limited_edition;
                  break;

                case 3:
                  result = rb.endeca.misc_flag_new_shades;
                  break;

                case 94:
                case 5:
                  result = rb.endeca.misc_flag_online_exclusive;
                  break;

                default:
                  return result;
              }

              return typeof result === 'undefined' ? '' : result;
            }

            // BEGIN: Handle non product tile injection
            $this.one('elProductComplete', function () {
              // DOM
              var $carousel = $this.find('.carousel_container .carousel');
              var $carouselChildren = $carousel.children(); // Cache existing child elements
              var $target;
              // LOGIC
              var elements = [];

              // Get elements to sort
              $this.find('.hidden-tile-markup .inline-mpp-tile').each(function () {
                var $this = $(this);
                var index = parseInt($this.attr('data-tile-index'));

                elements.push({
                  $element: $this,
                  index: index
                });
              });

              // Sort in decending order
              elements = elements.sort(function (a, b) {
                if (a.index > b.index) {
                  return -1;
                }

                if (a.index < b.index) {
                  return 1;
                }

                return 0;
              });

              // Insert elements
              elements.forEach(function (elementData) {
                $target = $carouselChildren.eq(elementData.index);

                if ($target.length === 0) {
                  $carousel.append(elementData.$element);
                } else {
                  elementData.$element.insertBefore($target);
                }
              });
            });
            // END: Handle non product tile injection

            // Clear trailing comma
            if (typeof $productList.html() === 'string' && $productList.html().trim().length !== 0) {
              $productList.html($productList.html().replace(/,$/, ''));
            }

            // Run EL Product plugin
            $this.find('.carousel_container').elproduct({
              target: '.el-product',
              template: '.hidden-products-markup-to-clone li',
              products: '.el-product_id-list',
              debug: false,
              map: {
                'AVERAGE_RATING': [
                  {
                    selector: '.el-product_stars-rating span',
                    targets: ['html', 'title']
                  },
                  {
                    selector: '.el-product_stars-rating span',
                    targets: ['class'],
                    modifier: function (data) {
                      if (typeof data !== 'number') {
                        return 'rating_0_0';
                      }

                      return 'rating_' + data.toFixed(1).replace('.', '_');
                    }
                  }
                ],
                'INVENTORY_STATUS': [
                  {
                    selector: '.el-product_shop-now',
                    targets: ['html'],
                    modifier: function (inventoryStatus) {
                      // LOGIC
                      var inventoryStatusLookup = {
                        2: $this.attr('data-cta-out-of-stock'), // Out of stock
                        3: $this.attr('data-cta-coming-soon'), // Coming soon
                        5: $this.attr('data-cta-inactive'), // Inactive
                        7: $this.attr('data-cta-sold-out') // Sold out
                      };

                      // Values not found in inventoryStatusLookup (undefined) indicate shoppable items
                      return inventoryStatusLookup[inventoryStatus];
                    }
                  },
                  {
                    selector: '.el-product, .el-product_shop-now',
                    targets: ['data-available'],
                    modifier: function (inventoryStatus) {
                      if (inventoryStatus === 3 || inventoryStatus === 7) {
                        return 'false';
                      }

                      return 'true';
                    }
                  }
                ]
              },
              onError: function () {
                $this.trigger('elProductComplete');
              },
              onSuccess: function () {
                // DOM
                var $products = $this.find('.el-product');
                // LOGIC
                var productSortData = {
                  all: [],
                  name: [],
                  newest: [],
                  rated: [],
                  'price-high': [],
                  'price-low': []
                };

                // Build sorted values
                // Build master product list from existing products
                $products.each(function () {
                  // DOM
                  var $this = $(this);
                  // LOGIC
                  var productData = $this.data('full_product_json');
                  var priceLow;
                  var priceLowFormatted;
                  var priceHigh;
                  var priceHighFormatted;
                  var skuPrice;
                  var skuFormattedPrice;
                  var imageSource;

                  if (typeof productData === 'undefined') {
                    return;
                  }

                  $this.attr('data-product', productData.PRODUCT_ID);

                  productData.skus.forEach(function (sku) {
                    skuPrice = sku.PRICE;
                    skuFormattedPrice = sku.formattedPrice;

                    if (typeof priceHigh === 'undefined' || skuPrice > priceHigh) {
                      priceHigh = skuPrice;
                      priceHighFormatted = skuFormattedPrice;
                    }

                    if (typeof priceLow === 'undefined' || skuPrice < priceLow) {
                      priceLow = skuPrice;
                      priceLowFormatted = skuFormattedPrice;
                    }
                  });

                  if (priceLow !== priceHigh) {
                    $this.find('.el-product_price').html(priceLowFormatted + '-' + priceHighFormatted);
                  }

                  if (typeof productData.defaultSku !== 'undefined') {
                    // Defaults to LARGE_IMAGE, no need to set for that property
                    switch (imageType) {
                      case 'SMALL_IMAGE':
                        imageSource = productData.defaultSku[imageType];
                        break;

                      case 'MEDIUM_IMAGE':
                        imageSource = productData.defaultSku[imageType];
                        break;

                      case 'XL_IMAGE':
                        imageSource = productData.defaultSku[imageType];
                        break;

                      case 'PINK_IMAGE':
                        imageSource = productData.defaultSku[imageType];
                        break;

                      default:
                        imageType = 'LARGE_IMAGE';
                        imageSource = productData.defaultSku[imageType];
                    }

                    // Use available image, if not available, default to LARGE_IMAGE
                    if (typeof imageSource !== 'undefined' && imageSource instanceof Array && imageSource.length !== 0) {
                      imageSource = imageSource[0];
                    } else {
                      imageSource = undefined;
                    }

                    if (imageType !== 'LARGE_IMAGE' && typeof imageSource === 'string') {
                      $this.find('img.el-product_image').attr('src', imageSource);
                    }
                  }

                  // Set Link
                  $this.find('.product-header > a, .product-image > a').attr('href', productData.url);

                  // Set eyebrow text
                  $this.find('.product-header .eyebrow').html(getEyebrowText(productData.MISC_FLAG));

                  // Set correct name
                  switch (titleType) {
                    case 'default-title':
                      $this.find('.product-header h3').html(productData.PROD_RGN_NAME);
                      break;
                    case 'collection-title':
                      $this.find('.product-header h3').html(productData.ATTRIBUTE_COLLECTION);
                      break;
                  }

                  productSortData.all.push({
                    $element: $this,
                    data: productData
                  });
                });

                // Sort by name
                productSortData.name = productSortData.all.slice(0).sort(function (a, b) {
                  var productDataA = a.data;
                  var productDataB = b.data;
                  var nameA = productDataA.PROD_RGN_NAME.toLowerCase();
                  var nameB = productDataB.PROD_RGN_NAME.toLowerCase();

                  return nameA.localeCompare(nameB, 'en');
                });

                // Sort by newest
                productSortData.newest = productSortData.all.slice(0);
                // Encapsulate newest sort as variables aren't expected to be used elsewhere.
                // Product "age" is via MISC_FLAG
                (function () {
                  var tempNewest = productSortData.newest.filter(function (element) {
                    return element.data.MISC_FLAG === 1 || element.data.MISC_FLAG === 3;
                  });
                  var tempOldest = productSortData.newest.filter(function (element) {
                    return !(element.data.MISC_FLAG === 1 || element.data.MISC_FLAG === 3);
                  });

                  productSortData.newest = tempNewest.concat(tempOldest);
                })();

                // Sort by rating
                productSortData.rated = productSortData.all.slice(0).sort(function (a, b) {
                  var productDataA = a.data;
                  var productDataB = b.data;
                  var ratingA = productDataA.AVERAGE_RATING;
                  var ratingB = productDataB.AVERAGE_RATING;

                  if (ratingA > ratingB) {
                    return 1;
                  }

                  if (ratingA < ratingB) {
                    return -1;
                  }

                  return 0;
                });

                // Sort by highest price
                productSortData['price-high'] = productSortData.all.slice(0).sort(function (a, b) {
                  var productDataA = a.data;
                  var productDataB = b.data;
                  var priceA = [];
                  var priceB = [];

                  productDataA.skus.forEach(function (sku) {
                    priceA.push(sku.PRICE);
                  });

                  priceA = Math.min.apply(null, priceA);

                  productDataB.skus.forEach(function (sku) {
                    priceB.push(sku.PRICE);
                  });

                  priceB = Math.min.apply(null, priceB);

                  if (priceA > priceB) {
                    return -1;
                  }

                  if (priceA < priceB) {
                    return 1;
                  }

                  return 0;
                });

                // Sort by lowest Price
                productSortData['price-low'] = productSortData.all.slice(0).sort(function (a, b) {
                  var productDataA = a.data;
                  var productDataB = b.data;
                  var priceA = [];
                  var priceB = [];

                  productDataA.skus.forEach(function (sku) {
                    priceA.push(sku.PRICE);
                  });

                  priceA = Math.min.apply(null, priceA);

                  productDataB.skus.forEach(function (sku) {
                    priceB.push(sku.PRICE);
                  });

                  priceB = Math.min.apply(null, priceB);

                  if (priceA > priceB) {
                    return 1;
                  }

                  if (priceA < priceB) {
                    return -1;
                  }

                  return 0;
                });

                $carousel.data('product-sort-data', productSortData);

                if ($this.hasClass('mpp-carousel')) {
                  $carousel.elCarouselUpdate();
                }

                $window.trigger('elProductSuccessComplete');
                $this.trigger('elProductComplete');
              }

            });
          });
        }
        // END: Init

        // BEGIN: Events
        events: {
          $mppCarousel.find('.carousel_pagers .arrow').on('click', function (e) {
            // DOM
            var $this = $(this);
            var $parent = $this.closest('.mpp-carousel');
            var $carousel = $parent.find('.carousel');

            e.preventDefault();

            if ($parent.length === 0) {
              return;
            }

            if ($this.hasClass('right')) {
              $carousel.carouselNext();
            } else if ($this.hasClass('left')) {
              $carousel.carouselPrev();
            }
          });

          // Handle resize
          $window.on('resize', _.debounce((function () {
            return function () {
              // Throttle resize
              /*
                     Required for section load, unload, and update functions called by this function
                     There may be additional animations and functionality implemented in those functions that need to be called.
                     Calling this after resize insures that sections "now" in view get updated while sections that are "now" out of view are unloaded
                  */
              // Add mobile class if desktop class scales under mobile size
              if (platformVars.isDesktop && !platformVars.isIpad) {
                if ($window.width() <= platformVars.mobileSize && !platformVars.$target.hasClass('mobile')) {
                  platformVars.$target.addClass('mobile');
                  platformVars.isMobile = true;
                  $window.trigger('desktopGainedMobile');

                  // Destroy each carousel
                  $mppCarousel.each(function () {
                    // DOM
                    var $this = $(this);
                    var $carousel = $this.find('.carousel');

                    $carousel.elCarouselDestroy();
                  });
                  $mppCarousel.find('.slide').removeAttr('style');
                } else if ($window.width() > platformVars.mobileSize && platformVars.$target.hasClass('mobile')) {
                  platformVars.$target.removeClass('mobile');
                  platformVars.isMobile = false;
                  $window.trigger('desktopLostMobile');

                  // Rebuild carousel if possible
                  $mppCarousel.each(function () {
                    // DOM
                    var $this = $(this);
                    var $carousel = $this.find('.carousel');

                    $carousel.elCarousel(carouselSettings);
                  });

                  // Hide all open quickshops
                  $mpp.find('.open').removeClass('open');
                }
              }

              // On Desktop and iPad .mpp-carousel elements should be sized to contents
              if (platformVars.isDesktop || platformVars.isIpad) {
                $mppCarousel.each(function () {
                  var $this = $(this);
                  var elProductHeightOffset = 0;

                  // Get tallest height
                  $this.find('.el-product').each(function () {
                    var targetHeight = $(this).outerHeight(true);

                    elProductHeightOffset = targetHeight > elProductHeightOffset ? targetHeight : elProductHeightOffset;
                  });

                  $this.height(elProductHeightOffset + $this.find('.mpp-header').outerHeight(true));
                });
              }
            };
          })(), 500))
            // Marks active mpps
            .on('scroll', _.throttle((function () {
              var prevScroll = 0;

              return function () {
                // DOM
                var $visibleMPPs = $mpp.not(':hidden');
                var $target;
                // LOGIC
                var scrollTop = $window.scrollTop();
                var scrollBottom = scrollTop + $window.height();
                var dir = -(prevScroll - scrollTop);
                var candidates = [];

                // Dir
                // 0 - No change
                // 1 - Positive (downwards scroll)
                // -1 - Negative (upwards scroll)
                dir = dir > 0 ? 1 : dir === 0 ? 0 : -1;

                // This was somehow getting the last step
                (dir === 1 ? $visibleMPPs : $($visibleMPPs.get().reverse())).each(function () {
                  // DOM
                  var $this = $(this);
                  // LOGIC
                  var sectionTop = $this.offset().top;
                  var sectionBottom = sectionTop + $this.outerHeight(true);
                  var overlapPercent;

                  if (scrollBottom >= sectionTop && sectionBottom >= scrollTop) {
                    overlapPercent = Math.max(0, Math.min(scrollBottom, sectionBottom) - Math.max(scrollTop, sectionTop) + 1) / $this.outerHeight(true);
                    candidates.push({
                      $element: $this,
                      overlap: overlapPercent
                    });
                  }
                });

                candidates = candidates.sort(function (a, b) {
                  if (a.overlap < b.overlap) {
                    return 1;
                  }

                  if (a.overlap > b.overlap) {
                    return -1;
                  }

                  return 0;
                });

                if (candidates.length !== 0) {
                  $target = candidates[0].$element;
                } else {
                  $target = $visibleMPPs.first();
                }

                // If a valid active class is found, mark it active, and remove that class from siblings
                if (typeof $target !== 'undefined') {
                  if (!$target.hasClass('active')) {
                    $target.trigger('gainedActive');
                  }

                  $target.addClass('active');
                  $mpp.not($target).filter('.active').trigger('lostActive');
                  $mpp.not($target).removeClass('active');
                }

                prevScroll = scrollTop;
              };
            })(), 100))
            .on('keydown', function (e) {
              // DOM
              var $targetMPPs = $mpp.filter('.mpp-carousel.active');
              var $carousels = $targetMPPs.find('.carousel');

              switch (e.which) {
                // Prev
                case 37:
                  $carousels.elCarouselPrev();
                  break;

                  // Next
                case 39:
                  $carousels.elCarouselNext();
                  break;
              }
            })
            .trigger('resize');

          // BEGIN: Add to Bag Button Functionality
          // Shop now handling
          $mpp.find('.el-product_shop-now.add-to-bag').off().on('click', function (e) {
            // DOM
            var $this = $(this);
            // LOGIC
            var productID = $this.data('product-id');

            e.preventDefault();

            if (!$this.hasClass('ready')) {
              return;
            }

            // Item must be available for purchase
            if ($this.attr('data-available') !== 'undefined' && $this.attr('data-available') === 'false') {
              return;
            }

            if (typeof productID !== 'undefined') {
              site.addToCart({
                skuData: {
                  SKU_BASE_ID: $this.data('productData').SKU_ID.substr(3),
                  PARENT_CAT_ID: productID
                },
                quantity: 1,
                QTY: 1
              });
            }
          });

          // Quickshop
          $mpp.find('.el-product_shop-now.quickshop').off('click').on('click', function (e) {
            // DOM
            var $this = $(this);
            var $parent = $this.closest('li');
            // LOGIC
            var productData = $this.data('full_product_json');

            e.preventDefault();

            if (typeof productData === 'undefined') {
              return;
            }

            // Item must be available for purchase
            if ($this.attr('data-available') !== 'undefined' && $this.attr('data-available') === 'false') {
              return;
            }

            if (platformVars.isMobile) {
              $mpp.find('.open').removeClass('open');

              if ($parent.hasClass('open')) {
                $parent.removeClass('open');
              } else {
                $parent.addClass('open');

                TweenMax.to($window, 0.2, { scrollTo: { y: $this.offset().top - $('header').height() } });
              }
            } else {
              site.quickshop(productData);
            }
          });
          // END: Add to Bag Button Functionality

          // BEGIN: Sort Functionality
          // Has helper variables and function(s) for the sort feature of this template
          // Functionality is encapsulated and not expected to be used elsewhere
          // It's still considered part of 'events'
          (function () {
            // DOM
            var $sortControls = $mpp.find('.product-sort-container');
            var $sortTrigger = $sortControls.find('.product-sort-button');
            var $sortMenu = $sortControls.find('.product-sort-dropdown');

            /**
                * @name setSort
                * @description Reorders DOM elements based on presorted data
                * @param {jQuery} $target A jQuery sort functionalityor
                * @param {string} sortName sort order to pick
                *   none - Normal order
                *   name - Sorted by name
                *   newest - Sorted by newest
                *   rate - Sorted by rating
                *   price-high - Sorted highest price first
                *   price-low - Sorted lowest price first
                * @returns {undefined} Nothing
                */
            function setSort($target, sortName) {
              // LOGIC
              var sortData;
              var selectedSort;

              // Must have a target and a sort index
              if ((typeof $target === 'undefined' || $target.length === 0) || typeof sortName !== 'string') {
                return;
              }

              sortData = $target.data('product-sort-data');

              // Must have pre-sorted data
              if (typeof sortData === 'undefined') {
                return;
              }

              selectedSort = sortData[sortName];

              if (typeof selectedSort !== 'undefined') {
                // Reorder elements in $target
                selectedSort.forEach(function (sort) {
                  $target.append(sort.$element);
                });
              }
            }

            $sortTrigger.on('click', function (e) {
              e.preventDefault();

              $(this).parent('.product-sort-container').toggleClass('open');
            });

            // Manipulate current sort
            // Sort page data and rebuild MPP
            $sortMenu.find('li').on('click', function (e) {
              // DOM
              var $this = $(this);
              var $targetMPP = $this.closest('.custom-mpp');
              // LOGIC
              var sortMethod = $this.data('sort');

              e.preventDefault();

              $sortControls.removeClass('open');
              $sortTrigger.find('.product-sort-by').html($this.html());

              setSort($targetMPP.find('.carousel'), sortMethod);
            });
          })();
          // END: Sort Functionality
        }
        // END: Events
      })();
      // /////////////////////////////////
      // END: MPP Carousel Custom functionality
      // /////////////////////////////////
    }
  };
})(jQuery);
